import { Link } from 'react-router';
import { periodsAwaitingApproval } from '../../../lib/build/request-periods.ts';
import type { RequestPeriod } from '../../api.ts';
import { Notice } from '../../components/Notice.tsx';
import { copy } from '../../copy/en-CA.ts';

const c = copy.admin.build.pending;

/** The request periods as loaded: null while loading, 'unavailable' when they could not be. */
export type PeriodsState = readonly RequestPeriod[] | 'unavailable' | null;

/**
 * Says, where the admin is about to generate or regenerate, that requests
 * in an overlapping period are still awaiting approval and will not be used
 * (the generator reads approved availability only). If the periods could
 * not be loaded it says so, rather than looking like nothing is waiting.
 * Not printed. The link opens Availability, which selects the open period
 * by itself; it cannot yet be told which period to select.
 */
export function PendingRequestsNotice({ periods, start, end }: { periods: PeriodsState; start: string; end: string }) {
  if (periods === null) return null;
  if (periods === 'unavailable') {
    return (
      <div className="no-print">
        <Notice kind="info">
          {c.unavailable} <Link to="/admin/availability">{c.unavailableLink}</Link>
        </Notice>
      </div>
    );
  }
  const waiting = periodsAwaitingApproval(periods, start, end);
  if (waiting.length === 0) return null;
  return (
    <div className="no-print pending-requests">
      <Notice kind="info">
        {waiting.map((p) => (
          <p key={p.id}>
            {c.text(p.pendingCount, p.name)} <Link to="/admin/availability">{c.link(p.pendingCount)}</Link>
          </p>
        ))}
      </Notice>
    </div>
  );
}
